<template>
  <section>
    <div class="columns is-centered">
      <div class="column is-6">
        <div class="section">
          <div class="container">
            <div class="modal-card">
              <header class="modal-card-head">
                <h1 class="modal-card-title">
                  Estimado Usuario,
                  <!---
                  {{ $t('NF3SN1') }} {{ neofintechData.userData.firstName }}
                  {{ neofintechData.userData.lastName }},
                  ---->
                </h1>
              </header>
              <div class="modal-card-body">
                <p>La firma del Acuerdo con Ecobanka se ha realizado correctamente.</p>
                <p>Una vez firmado por Ecobanka, le llegará a su email el documento firmado por ambas partes.</p>
                <p>En breve recibirá en su email la factura con los datos bancarios para realizar el pago mediante transferencia.</p>
                <!----
                <p>{{ $t('NF3SC2') }}</p>
                <p>{{ $t('NF3SC3') }}</p>
                <p>{{ $t('NF3SC4') }}</p>
                ---->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  mixins: [],
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  }
  
}
</script>
